import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  CreatedFolder,
  DossierDetail,
  DossiersResponse,
  SearchDossierResponse
} from './dossier.models';

export function wildcardSearchQuery(searchTerm: string): string {
  const term = searchTerm.trim();

  return term === '' || term.includes('*') ? term : `${term}*`;
}

@Injectable({
  providedIn: 'root'
})
export class DossierService {
  private readonly _http = inject(HttpClient);

  public searchDossier(searchTerm: string): Promise<SearchDossierResponse> {
    return firstValueFrom(
      this._http.get<SearchDossierResponse>('/api/office/Mailablage/SearchDossier', {
        params: { searchquery: wildcardSearchQuery(searchTerm) }
      })
    );
  }

  /** The running Geschäfte that have `absenderAdresse` as a dossier contact. */
  public getSenderDossiers(absenderAdresse: string): Promise<DossiersResponse> {
    return firstValueFrom(
      this._http.get<DossiersResponse>('/api/office/Mailablage/Dossiers', {
        params: { absenderAdresse }
      })
    );
  }

  public getDossier(dossierGuid: string): Promise<DossierDetail> {
    return firstValueFrom(
      this._http.get<DossierDetail>('/api/office/Mailablage/Dossier', {
        params: { dossierGuid }
      })
    );
  }

  /** Creates a folder below parentGuid, or right in the dossier root when it is null. */
  public createFolder(
    dossierGuid: string,
    titel: string,
    parentGuid: string | null
  ): Promise<CreatedFolder> {
    return firstValueFrom(
      this._http.post<CreatedFolder>('/api/office/Mailablage/OrdnerNeu', {
        dossierId: dossierGuid,
        titel,
        ...(parentGuid === null ? {} : { parentOrdnerId: parentGuid })
      })
    );
  }
}
